import React, { useState } from "react";
import CommentList from "../CommentList";
import Avatar from "components/BaseWidgets/Avatar";
import Button from "../../../BaseWidgets/button";
import { Filter } from "assets/icons";
import "./style.scss";
import CustomTextArea from "components/BaseWidgets/form/textArea";
import Divider from "components/BaseWidgets/divider";
import { useAddComment, useCommentLists } from "hooks/api/useBlogs";
import { useQueryClient } from "@tanstack/react-query";
import AlertNotification from "components/CustomWidgets/alertNotification";

const SORT_ORDER_ASC = 1;
const SORT_ORDER_DESC = 2;

function blogComments({ loggedUser, userName, comments }) {
  const [message, setMessage] = useState("");
  const [sortOrder, setSortOrder] = useState(SORT_ORDER_ASC);
  const queryClient = useQueryClient();

  const blogId = comments?.id;

  const { data: commentData } = useCommentLists(
    {
      blog_id: blogId,
      sort_order: sortOrder,
    },
    {
      enabled: !!blogId,
    },
  );

  const commentList = commentData || [];

  const { mutate: addComment, isLoading: iscommentLoading } = useAddComment({
    onSuccess: () => {
      AlertNotification("success", "Comment added successfully!");
      queryClient.invalidateQueries(["blogDetails", blogId]);
      queryClient.invalidateQueries(["comment-list", blogId]);
    },
  });

  const handleAddComment = () => {
    if (!message.trim()) return;
    addComment({ blog_id: blogId, comment: message });
    setMessage("");
  };

  const toggleSortOrder = () => {
    setSortOrder((prevOrder) =>
      prevOrder === SORT_ORDER_ASC ? SORT_ORDER_DESC : SORT_ORDER_ASC,
    );
  };

  return (
    <div className="comments-section">
      <Divider />
      <div className="comment-title-area flex items-center justify-between">
        <span className="font-body-xl fw-700">
          Comments ({commentList.length})
        </span>
        <Button variant="round" onClick={toggleSortOrder}>
          <Filter />
        </Button>
      </div>
      <div className="loggedin-user flex items-center gap-2">
        <Avatar url={loggedUser} />
        <p className="font-title-xs">{userName}</p>
      </div>
      <div className="text-area">
        <CustomTextArea
          inputClassname="input-class"
          placeholder={"What are your thoughts..."}
          id="Tell us more..."
          value={message}
          maxLength={500}
          onChange={(e) => setMessage(e.target.value)}
        />
      </div>
      <div className="comment-action">
        <Button onClick={handleAddComment} disabled={iscommentLoading}>
          Post
        </Button>
      </div>
      <div className="comment-list-wrapper">
        {commentList.length > 0 &&
          commentList.map((eachItem, index) => (
            <CommentList EachComments={eachItem} key={index} blogId={blogId} />
          ))}
      </div>
    </div>
  );
}

export default blogComments;
